module.exports = __webpack_public_path__ + "img/purple-rectangle-table-10.aa20b68b.png";